import React from "react";
import { useScroll, useTransform } from "framer-motion";
import {
  Particles,
  ProgressBar,
  Hero,
  About,
  TechnicalSkills,
  Experience,
  Education,
  Certifications,
  Projects,
  LanguagesAndSkills,
  Interests,
  Contact,
  Footer,
} from "./components";
import "./App.css";

function App() {
  const { scrollYProgress } = useScroll();
  const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "50%"]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-x-hidden">
      <Particles />
      <ProgressBar scrollYProgress={scrollYProgress} />
      <Hero backgroundY={backgroundY} />
      <About />
      <TechnicalSkills />
      <Experience />
      <Education />
      <Certifications />
      <Projects />
      <LanguagesAndSkills />
      <Interests />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
